/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonials_Subtitle_PrefixInputs */

const en_testimonials_subtitle_prefix = /** @type {(inputs: Testimonials_Subtitle_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over 50,000 people are using the app -`)
};

const es_testimonials_subtitle_prefix = /** @type {(inputs: Testimonials_Subtitle_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más de 50,000 personas usan la app -`)
};

/**
* | output |
* | --- |
* | "Over 50,000 people are using the app -" |
*
* @param {Testimonials_Subtitle_PrefixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonials_subtitle_prefix = /** @type {((inputs?: Testimonials_Subtitle_PrefixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonials_Subtitle_PrefixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonials_subtitle_prefix(inputs)
	return en_testimonials_subtitle_prefix(inputs)
});